import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { ReferralsService } from "../referrals.service";
import { ReferralProgram } from "../referrals.interfaces";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-programs-list",
  templateUrl: "./programs-list.component.html",
  styleUrls: ["./programs-list.component.css"],
})
export class ReferralProgramsListComponent implements OnInit, OnDestroy {
  public breadcrumb: string[] = [];
  public _items: ReferralProgram[] = [];
  public loading: boolean;

  constructor(
    private router: Router,
    private service: ReferralsService,
    private titleService: Title,
  ) {
    alertify.logPosition("bottom right");
  }

  ngOnInit() {
    this.titleService.setTitle(`Referral Programs | CODE Hospitality CMS`);
    this.loadItems();
    this.breadcrumb = ["Referral Programs"];
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private loadItems() {
    this.loading = true;
    this.service.getReferralPrograms().subscribe(
      (res) => {
        this._items = res.json();
        this.loading = false;
      },
      (err) => {
        alertify.error(err);
        this.loading = false;
      },
    );
  }

  /**
   * Get the list of referral programs sorted by non-archived programs first and all sorted by creation date
   * @return {ReferralProgram[]}
   */
  get items(): ReferralProgram[] {
    return this._items.sort((a, b) => {
      if (a.archivedAt && b.archivedAt) {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      }
      if (a.archivedAt) {
        return 1;
      }
      if (b.archivedAt) {
        return -1;
      }
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`,
      );
    }
  }

  private edit(item: ReferralProgram) {
    this.router.navigate(["/admin/referral-programs/edit"], {
      queryParams: { id: item.id },
    });
  }

  private delete(item: ReferralProgram) {
    this.loading = true;
    this.service.deleteReferralProgram(item.id).subscribe(
      (res) => {
        alertify.success("Referral program deleted successfully.");
        this.loadItems();
      },
      (err) => {
        this.alertError(err);
        this.loading = false;
      },
    );
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/referrals/programs/programs-list.component.ts